export default function removeVietnameseTones(str) {
  // Nếu không phải string thì trả về chính nó
  if (typeof str !== "string") return str;

  // Chuẩn hóa chuỗi thành dạng NFD (tách ký tự gốc + dấu)
  str = str.normalize("NFD");

  // Loại bỏ dấu tổ hợp (huyền, sắc, hỏi, ngã, nặng, mũ, ă, ơ, ư, …)
  str = str.replace(/[\u0300-\u036f]/g, "");

  // Chuyển riêng chữ đ/Đ
  str = str.replace(/đ/g, "d").replace(/Đ/g, "D");

  // Bỏ kí tự đặc biệt (nếu cần)
  str = str.replace(/[^0-9a-zA-Z\s]/g, " ");

  // Xóa khoảng trắng thừa
  return str.trim().replace(/\s+/g, " ");
}